module.exports = __webpack_public_path__ + "img/profile-img.7b633ece.svg";